<template>
  <div id="app">
    <b-modal centered ref="magicLinkModal" hide-footer hide-header no-close-on-backdrop no-close-on-esc>
      <div class="d-block text-center">
        <b-spinner class="spinner-default" style="width: 3rem; height: 3rem;" />
      </div>
      <div class="d-block text-center">
        <span>Spinning the discs...</span>
      </div>
    </b-modal>
    <b-modal :title="type.charAt(0).toUpperCase() + type.slice(1)" :header-bg-variant="type" centered ref="alertModal" hide-footer no-close-on-backdrop no-close-on-esc style="color: #FFFFFF">
      <div class="d-block text-center" style="color: black">
        {{text}}
      </div>
      <b-button variant="default" class="mt-3 text-white" block @click="closeAlert">OK</b-button>
    </b-modal>
    <router-view/>
  </div>
</template>

<script>
  import { EventBus } from "./EventBus";

  export default {
    name: "App",
    data() {
      return {
        text: '',
        type: ''
      }
    },
    methods: {
      showAlert() {
        if (this.$refs.alertModal) {
          this.$refs.alertModal.show();
        }
      },
      closeAlert() {
        this.$refs.alertModal.hide();
      }
    },
    mounted() {
      EventBus.$on('message', (data) => {
        this.text = data.message;
        this.type = data.type;
        this.showAlert();
      });
      EventBus.$on('loading-show', () => {
        if (this.$refs.magicLinkModal) {
          this.$refs.magicLinkModal.show();
        }
      });
      EventBus.$on('loading-hide', () => {
        if (this.$refs.magicLinkModal) {
          this.$refs.magicLinkModal.hide();
        }
        setTimeout(() => {
          this.$refs.magicLinkModal.hide();
        }, 2000);
      });
      EventBus.$on('logout', () => {
        this.$store.dispatch('setAuthStatus', false).then(() => {
          localStorage.removeItem('token');
          this.$router.replace('/');
        });
      });
      setInterval(() => {
        this.$axios.get('deck-spin').catch(err => {
          if (err.response.status && err.response.status === 401) {
            this.$store.dispatch('setAuthStatus', false).then(() => {
              localStorage.removeItem('token');
              this.$router.replace('/');
            });
          }
        });
      }, 300000);
    }
  }
</script>

<style>

  .btn-default {
    background-color: rgba(235, 63, 36,100) !important;
    color: #ffffff;
    border-color: #ffffff;
  }

  .btn-light {
    background-color: #ffffff !important;
    border-color:  rgba(235, 63, 36,100) !important;
    color: rgba(235, 63, 36,100) !important;
  }

  .image-container {
    text-align: center;
    margin-top: 20px;
  }

  .spinner-default {
    color: rgba(235, 63, 36,100) !important;
  }

  .table-hover tbody tr:hover {
    background-color: rgba(235, 63, 36, 100) !important;
    color: #ffffff;
  }
</style>
